import { hasQueryStringParameter } from 'owa-querystring';
import { isHostedInTeams } from './isHostedInTeams';
import { isOpxHostInitialized } from './getOpxHostApi';

// TODO: deprecate `isHostedInTeams` once Teams OPX partner has upgraded to modern OPX API
export function isOpx() {
    return (
        isOpxHostInitialized() ||
        hasQueryStringParameter('hostApp', window.location) ||
        isHostedInTeams()
    );
}
